import { type ISDK, Initialize } from '@tbwax_dev/mcd-family-sdk';
import { getUserState } from '@/redux/user/selectors';
import type { UserState } from '@/redux/user/types';
import { getLogged } from '@/redux/auth/selectors';
import { PageContainer } from './Home.styles';
import Overview from '@/components/Overview';
import { useEffect, useState } from 'react';
import { useAppSelector } from '@/redux';
import { isDEV } from '@/utils/Location';
import Tiles from '@/components/Tiles';
import { connect } from 'react-redux';

type HomeProps = {
  logged: boolean;
  user: UserState;
};

export const Home = ({ user, logged }: HomeProps) => {
  const auth = useAppSelector(state => state.auth);
  const [sdk, setSDK] = useState<ISDK>();

  useEffect(() => {
    user && logged && Initialize({
      campaignSlug: import.meta.env.VITE_CAMPAIGN_BASE_SLUG,
      apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
      apiKey: import.meta.env.VITE_API_KEY,
      onInitError: console.error,
      signInData: { user, auth },
      automaticLogin: true,
      onInit: setSDK,
      isDEV: isDEV()
    });
  }, [user, logged]);

  return (
    <PageContainer>
      <Overview sdk={sdk} />
      <Tiles sdk={sdk} lang={user.language} />
    </PageContainer>
  )
};

const mapStateToProps = (state: never) => ({
  user: getUserState(state),
  logged: getLogged(state)
});

export default connect(mapStateToProps)(Home);
